/**
 * Advanced device information detection using Modern Client Hints API
 * and robust User Agent fallback.
 */
export const getDeviceInfo = async () => {
    // 1. Modern API: UserAgentData (Chrome, Edge, Opera, Android WebView)
    // This is the most accurate way to get device model and platform.
    if (navigator.userAgentData) {
        try {
            // Requesting 'high entropy' values requires the browser's permission/logic
            // but usually works automatically for basic info.
            const hints = await navigator.userAgentData.getHighEntropyValues([
                'model',
                'platformVersion',
                'fullVersionList'
            ]);

            const platform = navigator.userAgentData.platform; // e.g., "Windows", "Android"
            const model = hints.model; // e.g., "SM-G991B" (Samsung S21)
            const isMobile = navigator.userAgentData.mobile;

            // Construct a cleaner name
            let nameParts = [platform];
            if (model) nameParts.push(model);
            if (!model && isMobile) nameParts.push('Mobile');

            // Get browser name from brand list
            const brand = navigator.userAgentData.brands.find(b =>
                !b.brand.includes('Not A') && !b.brand.includes('Chromium')
            ) || navigator.userAgentData.brands[0];

            return {
                deviceName: `${brand.brand}: ${nameParts.join(' ')}`,
                deviceType: isMobile ? 'mobile' : 'web'
            };
        } catch (e) {
            console.warn("UserAgentData failed, falling back to UA string", e);
        }
    }

    // 2. Fallback: Robust User Agent parsing (Safari, Firefox, older browsers)
    const ua = navigator.userAgent;
    let browserName = "Unknown Browser";
    let osName = "Unknown OS";
    let deviceType = "web";

    // Browser detection
    if (ua.includes("Firefox")) browserName = "Firefox";
    else if (ua.includes("SamsungBrowser")) browserName = "Samsung Browser";
    else if (ua.includes("Opera") || ua.includes("OPR")) browserName = "Opera";
    else if (ua.includes("Edge") || ua.includes("Edg")) browserName = "Edge";
    else if (ua.includes("Chrome")) browserName = "Chrome";
    else if (ua.includes("Safari")) browserName = "Safari";

    // OS detection
    if (ua.includes("Windows NT 10.0")) osName = "Windows 10/11";
    else if (ua.includes("Windows NT 6.1")) osName = "Windows 7";
    else if (ua.includes("Android")) {
        osName = "Android";
        deviceType = "mobile";
        // Try to extract Android model from UA
        const match = ua.match(/Android\s+([^\s;]+);\s+([^;)]+)/);
        if (match) osName = `Android (${match[2]})`;
    }
    else if (ua.includes("iPhone")) {
        osName = "iPhone";
        deviceType = "mobile";
    }
    else if (ua.includes("iPad")) {
        osName = "iPad";
        deviceType = "mobile";
    }
    else if (ua.includes("Mac OS X")) osName = "macOS";
    else if (ua.includes("Linux")) osName = "Linux";

    return {
        deviceName: `${browserName} on ${osName}`,
        deviceType: deviceType
    };
};
